import { arrIncludes } from ".";

export const checkFileType = (fileName?: string) => {
  const allowedExtensions = ["pdf"];
  const fileExt = fileName?.split(".").pop();

  return arrIncludes(allowedExtensions, fileExt);
};
